import { FeatureFlagOverrideManager } from "@src/featureFlags";
import HubspotScriptManager from "@src/HubspotScriptManager";
import InitializeTrackingManager from "@src/InitializeTrackingManager";
import { SitesContextProvider } from "@src/SitesContextProvider";
import { BackpackTelemetryManager } from "@src/telemetry";
import { UserContextProvider } from "@src/UserContextProvider";
import { UserEventManager } from "@src/UserEventManager";
import { FeatureFlags } from "./featureFlags";
import BackpackConsoleRouter from "./Router";

export default function BackpackAppRoot() {
  return (
    <>
      <InitializeTrackingManager />
      <FeatureFlagOverrideManager flags={FeatureFlags} />
      <UserContextProvider>
        <HubspotScriptManager />
        <SitesContextProvider>
          <UserEventManager />
          <BackpackTelemetryManager />
          <BackpackConsoleRouter />
        </SitesContextProvider>
      </UserContextProvider>
    </>
  );
}
